/* eslint-disable import/prefer-default-export */

export const SET_ACCOUNT = 'SET_ACCOUNT';
